import { render, staticRenderFns } from "./UserSupportTickets.vue?vue&type=template&id=02122c60&scoped=true&"
import script from "./UserSupportTickets.vue?vue&type=script&lang=js&"
export * from "./UserSupportTickets.vue?vue&type=script&lang=js&"
import style0 from "./UserSupportTickets.vue?vue&type=style&index=0&id=02122c60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02122c60",
  null
  
)

export default component.exports